export enum DiscoveryVersions {
    V1 = 1,
    V2 = 2
}
